import React, { useCallback } from 'react';
import { Chat } from '@axtria/hqi-genai'
import '@axtria/hqi-genai/lib/hqi-genai.css'
import  './monitor.scss'
import { useChat } from '../../hooks/useChat';
import { useNavigate } from 'react-router-dom';
const baseURL = process.env.REACT_APP_HQI_BASE_URL
const middlewareURL = process.env.REACT_APP_HQI_MIDDLEWARE_URL
const UMUrl = process.env.REACT_API_URL



const ChatComponent = () => {
  const {
    userInfo,
    chatConversation,
    getTeamName,
    chatKey,
    handleChatDelete,
    activeKnowledgeId,
    activeApp,
    isThinkingModeEnabled,
    apiVersionName,
    userProfileDetails
  } = useChat();
  console.log(activeKnowledgeId,[activeApp],isThinkingModeEnabled,userProfileDetails, "knowledge id");
    const navigate = useNavigate();

  const handleGoToArtifacts = useCallback(() => {
    navigate('/artifacts'); 
  }, [navigate]);
  return (
    <>
      {/* {!showChat && <div style={{display: 'flex', gap: '8px', padding: '10px'}}><Button onClick={e=>handleChat(null)}>New Chat</Button>
      <Button onClick={e=>handleChat('87783d92-9b95-49f7-942a-ea186b0d8f51')}>List HCPs with 5 or more calls in July and August 2023</Button></div>}

      <div style={{display:'flex', justifyContent:'flex-end', padding: '0px 10px', position: 'absolute', right: '0'}} onClick={e=>{setShowChat(false)}} ><FontAwesomeIcon icon={faClose} /></div>
      {showChat && <Chat  DOMAIN={"https://hqi-dev.axtria.com"}
      key={userInfo?.preferredProject}
                CONVERSATION_ID={chatConversation}
                PROJECT_ID={userInfo?.preferredProject}
                // userName={userInfo.first_name + " " + userInfo.last_name} 
                USERNAME={userInfo.first_name + " " + userInfo.last_name}
                />} */}
      <Chat  
        DOMAIN={baseURL}
        DOMAIN_MIDDLEWARE={middlewareURL}
        DOMAIN_UM={UMUrl}
        key={chatKey}
        CONVERSATION_ID={chatConversation}
        PROJECT_ID={userInfo?.preferredProject}
        TEAM={getTeamName()}
        USERNAME={`${userInfo?.first_name || ""}`}
        onDelete={handleChatDelete}
        KNOWLEDGE_ID={activeKnowledgeId}
        APPS={activeApp ? [activeApp] : []}
        config={{ thinking: isThinkingModeEnabled, validatorAgent: true, UI_Enhancement: apiVersionName === 'V2' }}
        USER_PROFILE_DETAILS={userProfileDetails}
         onGoToArtifacts={handleGoToArtifacts}
      />
    </>
  )
};

export default ChatComponent;
